module.exports = {
	"dk": {
		"googleAnalytics": {
			"test": "UA-37272945-14",
			"special": "UA-37272945-2",
			"prod": "UA-37272945-2"
		},
		"googleOptimize": {
			"special": "GTM-NCH56ZD",
			"prod": "GTM-NCH56ZD"
		},
		"gallup": {
			"siteId": "tv3sport"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/pageTracking.json
// module id = 423
// module chunks = 6